import { jsx as _jsx } from "react/jsx-runtime";
import { SettingsServiceIdentity } from "./settingsService";
import { ButtonLine } from "shared-ui-components/fluent/hoc/buttonLine";
import { useSetting } from "../hooks/settingsHooks";
import { SidePaneDockOverridesSettingDescriptor, LeftSidePaneWidthAdjustSettingDescriptor, LeftSidePaneHeightAdjustSettingDescriptor, RightSidePaneHeightAdjustSettingDescriptor, RightSidePaneWidthAdjustSettingDescriptor, } from "./shellService";
export const ShellSettingsServiceDefinition = {
    friendlyName: "Shell Settings Service",
    consumes: [SettingsServiceIdentity],
    factory: (settingsService) => {
        const settingRegistration = settingsService.addSectionContent({
            key: "Shell Settings",
            section: "UI",
            component: () => {
                const [, , resetSidePaneDockOverrides] = useSetting(SidePaneDockOverridesSettingDescriptor);
                const [, , resetLeftPaneWidthAdjust] = useSetting(LeftSidePaneWidthAdjustSettingDescriptor);
                const [, , resetLeftPaneHeightAdjust] = useSetting(LeftSidePaneHeightAdjustSettingDescriptor);
                const [, , resetRightPaneWidthAdjust] = useSetting(RightSidePaneWidthAdjustSettingDescriptor);
                const [, , resetRightPaneHeightAdjust] = useSetting(RightSidePaneHeightAdjustSettingDescriptor);
                return (_jsx(ButtonLine, { label: "Reset Layout", onClick: () => {
                        resetSidePaneDockOverrides();
                        resetLeftPaneWidthAdjust();
                        resetLeftPaneHeightAdjust();
                        resetRightPaneWidthAdjust();
                        resetRightPaneHeightAdjust();
                    } }));
            },
        });
        return {
            dispose: () => {
                settingRegistration.dispose();
            },
        };
    },
};
//# sourceMappingURL=shellSettingsService.js.map